import { action, observable, runInAction } from 'mobx';
import { FacilityScheduleForm, scheduleProperties } from 'application/facility/forms';
import {BaseEditViewStore, BaasicDropdownStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import {FacilityScheduleService, AreaOfCareService} from 'application/facility/services';
import {daysOfWeek} from 'core/utils/constants';
import { ModalParams } from 'core/models';
import _ from 'lodash';
@applicationContext
class FacilityScheduleViewStore extends BaseEditViewStore {
    @observable accessor itemsConstructed = false;
    @observable accessor selectedAreaOfCares = [];
    @observable accessor areaOfCares = [];    
    @observable accessor selectedAreaOfCare = null;

    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new FacilityScheduleService(rootStore.application.baasic.apiClient);
        const areaOfCareService = new AreaOfCareService(rootStore.application.baasic.apiClient);
        let facilitySchedule =  null;

        super(rootStore, {
            name: 'facility schedule',
            id: id,
            Form: FacilityScheduleForm,
            authorization: 'portalSection.upschedule',
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await service.find({facilityId: id, embed: 'Facility'});
                        facilitySchedule = _.find(response.data.item, {areaOfCareId: null});
                        let schedules = _.filter(response.data.item, item => {
                            return item.areaOfCareId != null;
                        });
                        let facility = {
                            facilitySchedule: facilitySchedule,
                            schedules: schedules
                        };
                        this.rootStore.viewStore.setNavigationOptions({
                            title: facilitySchedule.facility.name
                        });
                        return facility;
                    },
                    update: async (resource) => {
                        let schedules = [];
                        let existingSchedules = this.item.schedules;
                        _.forEach(resource.schedules, function(value, key){
                            if(key.includes('item'))
                            {
                                let schedule = _.find(existingSchedules, {areaOfCareId: value.areaOfCareId});
                                schedules.push(_.extend(schedule, value, {facilityId: id}));
                            }
                        });
                        schedules.push(_.extend(facilitySchedule, resource.facilitySchedule));
                        const response = await service.batchUpdate(schedules);
                        return response.data;
                    }
                }
            },
            FormClass: FacilityScheduleForm,
        });

        this.areaOfCareService = areaOfCareService;
        this.selectedAreaOfCare = null;
        this.daysOfWeek = daysOfWeek;

        this.generateModal = new ModalParams({});

        this.openGenerateModal = () => {
            this.generateModal.open({ 
                deliveryCalendarSelected: true, 
                orderingCalendarSelected: true,
                facilityId: this.id 
            });
        };
    }

    @action.bound
    async updateResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            await this.actions.update({
                id: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            this.rootStore.notificationStore.success("Facility Schedule successfully updated.");                                       
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error("Error occurred while trying to update Facility Schedule.");                                       
        }
    }

    @action.bound
    async attachDayOfTheWeekStore(item, isFacilitySchedule) {
        let areaOfCareId = item.areaOfCareId;
        item.daysOfWeekStore = new BaasicDropdownStore({
        }, {
            fetchFunc: async () => {
                return this.daysOfWeek;
            },
            onChange: (dayOfTheWeek) => this.setDayOfTheWeek(dayOfTheWeek, areaOfCareId, isFacilitySchedule)
        });
    }

    @action.bound
    setDayOfTheWeek(item, areaOfCareId, isFacilitySchedule) {
        if(isFacilitySchedule){
            this.form.fields.get('facilitySchedule').fields.get('dayOfTheWeek').set(item);                  
        }else{
            this.form.fields.get('schedules').fields.get('item-'+areaOfCareId).fields.get('dayOfTheWeek').set(item);                  
        }
    }

    @action.bound
    async getResource(id) {
        await super.getResource(id);
        const response = await this.areaOfCareService.find({ rpp: 10 });
        runInAction(() => {
            this.areaOfCares = response.data.item;
            this.selectedAreaOfCares = _.map(this.item.schedules, 'areaOfCareId');
        });
        await this.attachDayOfTheWeekStore(this.item.facilitySchedule, true);
        this.setDayOfTheWeek(this.item.facilitySchedule.dayOfTheWeek, null, true);

        this.areaOfCareStore = new BaasicDropdownStore({
            disabled : !this.hasPermission
        }, {
            fetchFunc: () => {
                let result = _.filter(this.areaOfCares, areaOfCare => {
                    var selected = _.find(this.selectedAreaOfCares, item => {
                        return areaOfCare.id === item
                    });
                    return !selected;
                });
                return result;                   
            },
            onChange: (areaOfCare) => {
                this.selectedAreaOfCare = areaOfCare;
            }
        });
       
        var itemsField = this.form.fields.get('schedules');
        for(const item of this.item.schedules){
            item.areaOfCareName = (_.find(this.areaOfCares, {id: item.areaOfCareId})).name;
            var field = {
                name: 'item-' + item.areaOfCareId,
                fields: _.map(scheduleProperties.fields, i => _.extend(i, {disabled: !this.hasPermission}))
            };
            itemsField.add(field);
            await this.attachDayOfTheWeekStore(item);
            itemsField.fields.get(field.name).set(item);
        }

        runInAction(() => {
            this.itemsConstructed = true;
        });
    }

    @action.bound
    removeSchedule(areaOfCareId) {
        this.item.schedules = _.filter(this.item.schedules, item => {
            return item.areaOfCareId != areaOfCareId;
        }); 
        this.selectedAreaOfCares = _.filter(this.selectedAreaOfCares, item => {
            return item != areaOfCareId;
        });      
        this.form.fields.get('schedules').fields.delete('item-'+ areaOfCareId);
        this.areaOfCareStore.filterAsync();                
    } 

    @action.bound
    async addSchedule() {  
        var selectedAreaOfCare = this.areaOfCareStore.value;
        if(!selectedAreaOfCare || _.find(this.item.schedules, {areaOfCareId: selectedAreaOfCare.id}) != null){
            return;
        }

        var itemsField = this.form.fields.get('schedules');
        var item = {
            areaOfCareName: selectedAreaOfCare.name,           
            areaOfCareId: selectedAreaOfCare.id
        };
        var field = {
            name: 'item-' + item.areaOfCareId,
            fields: scheduleProperties.fields
        };
        itemsField.add(field);
        this.attachDayOfTheWeekStore(item);                   
        itemsField.fields.get(field.name).set(item);        

        this.item.schedules.push(item);     

        this.selectedAreaOfCares.push(selectedAreaOfCare.id);        
        this.areaOfCareStore.setValue(null);
        this.selectedAreaOfCare = null;
        this.areaOfCareStore.filterAsync();      
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default FacilityScheduleViewStore;
